import React from 'react';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ColumnDefinition } from '../../../../../../types/ReactTableTypes';
import ExpanderIcon from '../../../../../components/expanderIcon';
import TeamDisplayModule from '../../../../../components/teamDisplayModule';

import BaseColumnDefinitions from './baseColumnDefinitions';

type ColumnOption = {
    headerColumn?: boolean;
    minWidth?: number;
};

export const nullTies = '--';
export const sumCount = (data) => data.reduce((acc, item) => acc + item, 0);

export const createAggColumn = (header, accessor, headerDescription, options: ColumnOption = {}) => {
    const columnsDef: ColumnDefinition = {
        Header: BaseColumnDefinitions.CreateHeaderCell(headerDescription, header),
        accessor: accessor,
        minWidth: options.minWidth ? options.minWidth : 50,
        aggregate: (values) => sumCount(values),
    };
    if (options.headerColumn) {
        columnsDef.headerClassName = 'header-column-start';
        columnsDef.className = 'column-start';
    }
    return columnsDef;
};

export const aggregateTieCount = (values) => {
    const sum = values.reduce((acc, item) => {
        if (item === null || item === undefined) {
            return acc;
        }
        if (acc === -1) {
            return item;
        }
        return acc + item;
    }, -1);
    return sum === -1 ? nullTies : sum;
};

export const createTieColumn = (header, accessor, headerDescription, options = {}) => {
    const columnsDef = createAggColumn(header, accessor, headerDescription, options);

    columnsDef.aggregate = (values) => aggregateTieCount(values);

    columnsDef.Cell = (cellData) => {
        // This is a hack associated to: https://github.com/react-tools/react-table/issues/882
        if (cellData.original) {
            return <span>{cellData.original[accessor] == null ? nullTies : cellData.original[accessor]}</span>;
        }
        return cellData.value;
    };

    columnsDef.sortType = (a, b) => {
        const value1 = a.original[accessor];
        const value2 = b.original[accessor];
        if (value1 === value2) {
            return 0;
        } else if (value1 === nullTies) {
            return -1;
        } else if (value2 === nullTies) {
            return 1;
        }
        return value1 > value2 ? 1 : -1;
    };
    return columnsDef;
};

const getVideoIconContent = (videoId, setVideoId) =>
    videoId ? (
        <FontAwesomeIcon
            icon={solid('film')}
            className="registryVideoIcon"
            onClick={() => {
                setVideoId(videoId);
            }}
        />
    ) : (
        ''
    );

export const getRegistryCellContent = (cellData, setVideoId, createRegistryContent, activeField, endSeasonField) => {
    const { canExpand, isExpanded } = cellData.row;

    if (canExpand) {
        const values = cellData.row.subRows[0].original;

        const pivotProps = cellData.row.getToggleRowExpandedProps();
        pivotProps.onClick = (e) => {
            // We will only expand the row if the Coach Name is not clicked
            if (e.target.nodeName !== 'A') {
                cellData.row.toggleRowExpanded();
            }
        };
        return (
            <div className={isExpanded ? 'pivot-expanded' : 'pivot'} {...pivotProps}>
                <span className={`registryNameContainer ${values[activeField] ? 'bold' : ''}`}>
                    {createRegistryContent(values)}
                    {getVideoIconContent(values.videoId, setVideoId)}
                </span>

                {isExpanded ? ' (Totals)' : ''}

                {ExpanderIcon(isExpanded)}
            </div>
        );
    }
    if (cellData.original) {
        const videoId = cellData.original.aggregatedVideoId;
        return (
            <div className="teamNameContainer">
                <TeamDisplayModule team={cellData.original} season={cellData.original[endSeasonField]} useInTable />
                {getVideoIconContent(videoId, setVideoId)}
            </div>
        );
    }
    return '';
};
